import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import Cookie from "js-cookie";

import {
  httpGetConsignmentContractStatusById,
  httpPostSaveVendorStatusByProfileId,
  httpPostAPRequestDBMApproval
} from "../../../../service/httpClient";
import * as Constants from "../../../../constants/Constants";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import * as RolePermissionConstants from "../../../../constants/RolePermissionConstants";
import "./DocumentCenter.css";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";

export const VendorContract = ({
  vendorId,
  onboardingStatus,
  refreshDataAfterActionSuccessful,
  contractType ='',
  selectedRows =[],
  isFrom=''
}) => {
  const [vendorContractDetails, setVendorContractDetails] = useState({
    showButton: false,
    vendorContract: null,
    showModal: false,
    errorStatus:false,
    errorMsg:'',
  });

  const store = useSelector(
    ({ service }) => ({
      vendorProfileStatus: service.vendorStatus || [],
    }),
    shallowEqual
  );

  const isValidateContractUrl = (contractObj) => {
    contractObj = contractObj || {};
    return (
      Object.entries(contractObj).length !== 0 && 
      contractObj.constructor === Object && 
      contractObj?.agreementUrl
    ) ? true : false;
  }

  useEffect(() => {
    if(vendorId) {
      getAgreementDetails();
    }
  }, [vendorId]);

  const getAgreementDetails = () => {
     const contractStatusType = contractType && contractType === Constants.DEI_TYPE? Constants.DEI_TYPE :Constants.CONSIGNMENT_TYPE
    httpGetConsignmentContractStatusById(vendorId,contractStatusType)
      .then((response) => {
        const contract = response?.data;
        setVendorContractDetails({
          vendorContract: contract,
          showButton: (isValidateContractUrl(contract) ? true : false),
          errorStatus: (isValidateContractUrl(contract) ? false : true),
          errorMsg : (isValidateContractUrl(contract) ? '' : Constants.API_GET_AGREEMENT_ERROR_MSG),
        });
        if(isFrom === "mbeDashboard"){
          openAgreement(contract);
        }      
      })
      .catch((error) => {
        setVendorContractDetails({
          ...vendorContractDetails,
          errorStatus: true,
          showButton: true,
          errorMsg:Constants.API_GET_AGREEMENT_ERROR_MSG,
        });
      });
  };

  const openAgreement = (vContract) => {
    let contract = { ...vendorContract };
    if (vContract) {
      contract = vContract;
    }
    if (isFrom === "mbeDashboard" && !contract.contractSignedByVendor) {
      setVendorContractDetails({
        vendorContract: null,
        showButton: false,
        errorStatus: true,
        showModal: true,
        errorMsg: Constants.AGGREMENT_PENDING_FOR_CEO_SIGN,
      });
    } else {
      setVendorContractDetails({
        showModal: true,
        showButton: false,
        vendorContract: contract,
        errorStatus: isValidateContractUrl(contract) ? false : true,
        errorMsg: isValidateContractUrl(contract)
          ? ""
          : Constants.API_GET_AGREEMENT_ERROR_MSG,
      });
    }
  };

  const refreshAgreementDetails = () => {
    const contract = { ...vendorContract };
    setVendorContractDetails({
      showModal: true,
      showButton: false,
      vendorContract: contract,
    });
    updateAgreementDetails();
  };

  const updateAgreementDetails = () => {
    httpGetConsignmentContractStatusById(vendorId,Constants.CONSIGNMENT_TYPE)
      .then((response) => {
        const contract = response?.data;
        setVendorContractDetails({
          vendorContract: contract,
          showButton: true,
          errorStatus: (isValidateContractUrl(contract) ? false : true),
          errorMsg : (isValidateContractUrl(contract) ? '' : Constants.API_GET_AGREEMENT_ERROR_MSG),
        });

        if (
          contract?.contractSignedByVP ||
          contract?.contractSignedByVendor
        ) {
          let vendorStatusUpdate = {};

          if (
            contract?.contractSignedByVP &&
            !contract?.contractSignedByVendor
          ) {
            vendorStatusUpdate =
              store?.vendorProfileStatus.length > 0
                ? store?.vendorProfileStatus.find(
                    (item) =>
                      item.statusName ===
                        Constants.CONSIGNMENT_VENDOR_PENDING_STATUSNAME &&
                      item.vendorStatus?.statusId === 35
                  )
                : {};
          } else if (
            contract?.contractSignedByVendor &&
            contract?.contractSignedByVP
          ) {
            vendorStatusUpdate =
              store?.vendorProfileStatus.length > 0
                ? store?.vendorProfileStatus.find(
                    (item) =>
                      item.statusName === Constants.DBM_SUBMISSION_STATUSNAME &&
                      item.vendorStatus?.statusId === 30
                  )
                : {};
          }
          const userEmail = Cookie.get("email")
            ? Cookie.get("email").toLowerCase()
            : "";
          const updatedByFullName = Cookie.get("userName")
            ? Cookie.get("userName")
            : "";
          const payLoad = {
            ...vendorStatusUpdate,
            vendorStatus: {
              ...vendorStatusUpdate.vendorStatus,
              lastStatusUpdatedValue: Constants.APPROVED,
              lastStatusUpdatedBy: userEmail,
            },
            userEmail,
            updatedByFullName,
          };

          httpPostSaveVendorStatusByProfileId(payLoad)
            .then((res) => {
              if (res?.status === 200) {
                refreshDataAfterActionSuccessful(res?.data);
              } else {
                setVendorContractDetails({
                  ...vendorContractDetails,
                  errorStatus: true,
                  errorMsg:Constants.API_ERROR_MSG,
                  showModal: false,
                  showButton: true,
                });
              }
            })
            .catch((err) => {
              setVendorContractDetails({
                ...vendorContractDetails,
                errorStatus: true,
                errorMsg:Constants.API_ERROR_MSG,
                showModal: false,
                showButton: true,
              });
            });
        }
      })
      .catch((error) => {
        setVendorContractDetails({
          ...vendorContractDetails,
          errorStatus: true,
          errorMsg:Constants.API_GET_AGREEMENT_ERROR_MSG,
          showModal: false,
          showButton: true,
        });
      });
  };
const handleSubmit = async () => {
  const contractStatusType =
    contractType && contractType === Constants.DEI_TYPE
      ? Constants.DEI_TYPE
      : Constants.CONSIGNMENT_TYPE;
  const response = await httpGetConsignmentContractStatusById(
    vendorId,
    contractStatusType
  );
  if (response?.data?.contractSignedByVP) {
    httpPostAPRequestDBMApproval({
      vendorProfileIds: selectedRows,
      merchApprovedBy: Cookie.get("email"),
    })
      .then((res) => {
        if (res && res.status === 200) {
          refreshDataAfterActionSuccessful();
          setVendorContractDetails({
            ...vendorContractDetails,
            errorStatus: true,
            errorMsg: "",
            showModal: false,
            showButton: false,
          });
        } else {
          setVendorContractDetails({
            ...vendorContractDetails,
            errorStatus: true,
            errorMsg: "",
            showModal: false,
            showButton: false,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          error.response &&
          (error.response.status === 400 || error.response.status === 404)
        ) {
          setApprovalErrorMsg(error.response?.data?.message);
        } else {
          setApprovalErrorMsg(error.message);
        }
        setApproveBtnDisabled(false);
      });
  } else {
    setVendorContractDetails({
      ...vendorContractDetails,
      errorStatus: true,
      errorMsg: "",
      showModal: false,
      showButton: false,
    });
  }
};
  const { vendorContract, showButton, showModal, errorStatus, errorMsg} = vendorContractDetails;

  const getShowButton = () => {
    if (isFrom === "mbeDashboard" && !vendorContract?.contractSignedByVendor) {
      return true;
    }
    return false;
  };
  return (
    <>
      <Modal
        dialogClassName="vc-modal-container"
        show={showModal}
        onHide={() => isFrom === 'mbeDashboard' ? handleSubmit() : refreshAgreementDetails()}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="m-top-10">
            <ErrorContainer
              errorMsg={errorMsg}
              updateStatus=''
              successMsg=''
              errorStatus={errorStatus}
              errorStyle="errorMessage"
              successStyle="successMessage"
            />
          </div>
          <embed
            src={vendorContract?.agreementUrl}
            className="vc-modal-embed-container"
          />
        </Modal.Body>
        {isFrom === 'mbeDashboard' &&
        <Modal.Footer>
        <Row>
            <Col>
              <Button
                id="dbmApprovalBtn"
                size="md"
                className="btn-primary-dbm-approval dbmApprovalBtn"
                onClick={() => handleSubmit(true)}
                disabled={errorStatus || getShowButton()}
              >
                {Constants.APPROVE_BUTTON}
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
        }
      </Modal>
      {showButton && (
        <div className="flexChild reviewContract">
          {!vendorContract?.contractSignedByVP &&
          (onboardingStatus === Constants.ACCOUNTS_PAYABLE_VP_PENDING || 
           onboardingStatus === Constants.CONSIGNMENT_VENDOR_PENDING) &&
          getUserRolePermission(
            RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
            RolePermissionConstants.VMS_REVIEW_CONSIGNMENT_CONTRACT_APVP_BUTTON
          ) === RolePermissionConstants.EDIT ? (
            <button
              onClick={() => openAgreement()}
              className="reviewContractBtn"
            >
              {Constants.REVIEW_CONSIGNMENT_CONTRACT}
            </button>
          ) : !vendorContract?.contractSignedByVendor &&
            onboardingStatus === Constants.CONSIGNMENT_VENDOR_PENDING &&
            getUserRolePermission(
              RolePermissionConstants.VENDORPLATFORM_PREBOARDING_DOCUMENTCENTER,
              RolePermissionConstants.VMS_REVIEW_CONSIGNMENT_CONTRACT_VENDOR_BUTTON
            ) === RolePermissionConstants.EDIT ? (
            <button
              onClick={() => openAgreement()}
              className="reviewContractBtn"
            >
              {Constants.REVIEW_CONSIGNMENT_CONTRACT}
            </button>
          ) : (
            ""
          )}
        </div>
      )}      
    </>
  );
};
